import { render, staticRenderFns } from "./SoccerRound.vue?vue&type=template&id=b92efdfa&scoped=true&"
import script from "./SoccerRound.vue?vue&type=script&lang=js&"
export * from "./SoccerRound.vue?vue&type=script&lang=js&"
import style0 from "./SoccerRound.vue?vue&type=style&index=0&id=b92efdfa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b92efdfa",
  null
  
)

export default component.exports